import { CheckBox, Table } from '@factorialco/deprecated-design-system'

import type { WithMultiSelectStateChildrenProps } from 'modules/core/components/WithMultiSelectState'

import { ImportedProjectProps, ProjectsToImport } from 'modules/project_management/lib/types'

import CellContent, { LegalEntity } from './CellContent'

type WithMultiSelectProps = WithMultiSelectStateChildrenProps<ProjectsToImport>
interface BodyProps {
  onToggleSelectedItem: WithMultiSelectProps['onToggleSelectedItem']
  projectsList: ProjectsToImport[]
  selected: ProjectsToImport[]
  tabId: string
  legalEntities: LegalEntity[]
  defaultCurrency: string
}

const Body = ({
  onToggleSelectedItem,
  projectsList,
  tabId,
  selected,
  legalEntities,
  defaultCurrency,
}: BodyProps) => {
  return (
    <Table.Body>
      {projectsList?.map((project, index) => {
        const projectNames = selected.map((p) => p.project_name)
        const checked = projectNames.includes(project.project_name)

        return (
          <Table.Row key={index}>
            <Table.Cell colSpan={1}>
              <CheckBox
                checked={checked}
                disabled={tabId === 'errored'}
                onClick={() => onToggleSelectedItem(project)}
              />
            </Table.Cell>

            {Object.values(ImportedProjectProps).map((prop, propIndex) => (
              <CellContent
                key={propIndex}
                project={project}
                projectProp={ImportedProjectProps[prop]}
                legalEntities={legalEntities}
                defaultCurrency={defaultCurrency}
              />
            ))}
          </Table.Row>
        )
      })}
    </Table.Body>
  )
}

export default Body
